import {
    Dialog,
    // FormControl,
    Grid,
    // InputLabel,
    // MenuItem,
    // Select,
    TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Stack from '@mui/material/Stack';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// import moment from "moment";
import { createExpert, fetchMissionExperts } from '../../../Api/suiviMission/experts';
// import { createTask } from "../../../Api/suiviMission/tasks";
import { useGlobalContext } from '../../../Contexts/suiviMission/GlobalContext';
import { buttonStyles } from '../../docsAdministrative/JsObjectStyles';

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

const styles = {
    dialogPaper: {
        minHeight: '45vh',
        maxHeight: '45vh',
    },
};

function AddExpertModal({ handleClose, open, classes }) {

    AddExpertModal.propTypes = {
        classes: PropTypes.any,
        open: PropTypes.func,
        handleClose: PropTypes.func,
    };
    const [missionExperts, setmissionExperts] = useState([]);
    const { mission } = useGlobalContext();
    // const [value, setValue] = useState(new Date().now);
    const { i18n } = useTranslation();
    const defaultValues = {
        personalData: {
            firstname: '',
            lastname: '',
            email: '',
            phoneNumber: '',
        },
        company: {
            name: 'EMGS',
        },
    };
    useEffect(() => {
        fetchMissionExperts(setmissionExperts, mission._id);
    }, []);
    const [formValues, setFormValues] = useState(defaultValues);
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name !== 'name') {
            setFormValues((current) => {
                return {
                    ...current,
                    personalData: {
                        ...current.personalData,

                        // 👇️ override value for nested country property
                        [name]: value,
                    },
                };
            });
        }
        else {
            setFormValues((current) => {
                return {
                    ...current,
                    company: {
                        ...current.company,

                        // 👇️ override value for nested country property
                        [name]: value,
                    },
                };
            });
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        //api call
        console.log('from AddExpertModal', formValues, missionExperts);
        createExpert(formValues);
        handleClose();
    };

    return (
        <div>
            <Dialog
                fullWidth="true"
                maxWidth="md"
                maxHeight="md"
                open={open}
                onClose={handleClose}
                scroll="body"
                classes={{ paper: classes.dialogPaper }}
            >
                <form onSubmit={(e) => handleSubmit(e)}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            xs={12}
                        >
                            <Box
                                sx={{ color: '#5778FF' }}
                                className="fw-bold text-center mt-2"
                            >
                                {i18n.t('Nouveau Collaborateur')}
                            </Box>
                            <p> {i18n.t('normalement l expert ne doit pas etre ajoutee dans l outil de suivi, mais plutots dans la partie cration de mission et affection des collaborateur, PAR le backOffice')} </p>
                        </Grid>
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            xs={6}
                        >
                            <Stack>
                                <TextField
                                    id="outlined-basic"
                                    label={i18n.t('Nom')}
                                    variant="outlined"
                                    fullWidth
                                    name="lastname"
                                    value={formValues.personalData.lastname}
                                    onChange={handleChange}
                                />
                                <TextField
                                    id="outlined-basic"
                                    label={i18n.t('Email')}
                                    variant="outlined"
                                    fullWidth
                                    name="email"
                                    value={formValues.personalData.email}
                                    onChange={handleChange}
                                />
                                <TextField
                                    id="outlined-basic"
                                    label={i18n.t('Entreprise')}
                                    variant="outlined"
                                    fullWidth
                                    name="name"
                                    value={formValues.company.name}
                                    onChange={handleChange}
                                />
                            </Stack>
                        </Grid>
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            xs={6}
                        >
                            <Stack>
                                <TextField
                                    id="outlined-basic"
                                    label={i18n.t('Prénom')}
                                    variant="outlined"
                                    fullWidth
                                    name="firstname"
                                    value={formValues.personalData.firstname}
                                    onChange={handleChange}
                                />
                                <TextField
                                    id="outlined-basic"
                                    label={i18n.t('Tél')}
                                    variant="outlined"
                                    fullWidth
                                    name="phoneNumber"
                                    value={formValues.personalData.phoneNumber}
                                    onChange={handleChange}
                                />
                            </Stack>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Button
                                variant="outlined"
                                color="success"
                                type="submit"
                                style={{...buttonStyles()}}
                            >
                                {i18n.t('Créer')}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Dialog>
        </div>
    );
}

export default withStyles(styles)(AddExpertModal);
